// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__35aQ7","fileDisabled":"File_fileDisabled__2PJNk"};